import React, { type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useIntl } from '@atlassian/jira-intl';
import { LeftFooterButton } from '../../../../common/ui/left-footer-button/index.tsx';
import messages from './messages.tsx';

type Props = {
	onShowMore: (mouseEvent: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

const ShowMoreButton = ({ onShowMore }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<LeftFooterButton
			message={formatMessage(messages.showMoreButtonText)}
			onClick={onShowMore}
			appearance="link"
			testId="jql-builder-basic-picker.ui.async-select.menu-list.show-more-button"
			hasTooltip={false}
			label={formatMessage(messages.showMoreButtonLabel)}
		/>
	);
};

export default ShowMoreButton;
